import { GatsbyImage } from "gatsby-plugin-image"
import React, { useEffect, useMemo, useRef } from "react"
import getGatsbyImage from "utils/getGatsbyImage"
import useWindowSize from '../../../hooks/useWindowSize'
import { Wrapper, Quote, SpacerContent, Content } from './shared.styles'

interface IProps {
  starsImage: any
  quotes: {
    text: string
    author: {
      name: string
      title: string
    }
  }[]
}

const RatingsHeroScrolling = (props: IProps) => {
  const contentRef = useRef<HTMLDivElement | null>(null)
  const quotes = [...props.quotes]

  const contentWidth = quotes.length * 315

  const { width } = useWindowSize()

  const animated = useMemo(() => {
    return width > 0 && contentWidth >= width
  }, [contentWidth, width])

  const renderedQuotes = useMemo(() => {
    if (animated) return [...quotes, ...quotes]
    return quotes
  }, [animated])

  useEffect(() => {
    if (contentRef.current) {
      if (animated) {
        contentRef.current?.classList.add('animated')
      } else {
        contentRef.current.classList.remove('animated')
      }
    }
  }, [animated])

  return <Wrapper>
    <SpacerContent>
      {quotes.map((q, i) => (
        <Quote key={i} className={`quote-${i}`}>
          <GatsbyImage
            image={getGatsbyImage(props.starsImage.localFile)}
            alt="Stars"
          />
          <p>&quot;{q.text}&quot;</p>
          <div>{q.author.name}</div>
          <div>{q.author.title}</div>
        </Quote>
      ))}
    </SpacerContent>
    <Content ref={contentRef} key='1' contentWidth={contentWidth * 2} nbItems={renderedQuotes.length} scrollBy={contentWidth}>
      {renderedQuotes.map((q, i) => (
        <Quote key={i} className={`quote-${i}`}>
          <GatsbyImage
            image={getGatsbyImage(props.starsImage.localFile)}
            alt="Stars"
          />
          <p>&quot;{q.text}&quot;</p>
          <div>{q.author.name}</div>
          <div>{q.author.title}</div>
        </Quote>
      ))}
    </Content>
  </Wrapper>
}

export default RatingsHeroScrolling
